export { default as CreateSkillGroupModalController } from './CreateSkillGroupModalController';
export { CreateSkillGroupModal }                      from './CreateSkillGroupModal';



// WEBPACK FOOTER //
// ./src/components/createSkillGroupModal/index.js